export class CopilotRiskControlSuggestionsRequestDTO {
  riskId: number;

  constructor() {
    this.riskId = 0;
  }
}

export class CopilotRiskControlSuggestionDTO {
  controlId: number;

  code?: string;

  name?: string;

  constructor() {
    this.controlId = 0;
  }
}

export class CopilotRiskControlSuggestionsDTO {
  controls?: CopilotRiskControlSuggestionDTO[];
}
